/**
 * Thrown when an order being tracked no longer exists on the server
 * (completed, deleted, or rotated). Callers should treat this as an
 * expected terminal state, not a failure — typically by clearing
 * local tracking state without surfacing an error to the user.
 */
export class OrderNoLongerAvailableError extends Error {
  readonly orderId: string
  constructor(orderId: string) {
    super(`Order ${orderId} is no longer available for tracking`)
    this.name = 'OrderNoLongerAvailableError'
    this.orderId = orderId
  }
}
